// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  min-height: 100vh;
  padding: 2rem 0;
}

.dashboard-header {
  text-align: center;
  margin-bottom: 3rem;
  color: white;
}

.dashboard-title {
  background: linear-gradient(135deg, #ffffff, #e2e8f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  /* margin-bottom: 0.5rem !important; */
}

.register-button {
  background: linear-gradient(135deg, #ffffff, #f8fafc) !important;
  color: #1e40af !important;
  font-weight: 600 !important;
  padding: 12px 32px !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.2) !important;
  text-transform: none !important;
}

.register-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 15px 40px rgba(255, 255, 255, 0.3) !important;
}

.registration-card {
  height: 100%;
  transition: all 0.3s ease !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px) !important;
} 

.registration-card:hover {
  transform: translateY(-8px) !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 1rem;
}

.status-chip {
  font-size: 0.75rem !important;
  height: 24px !important;
}

.card-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
}

.dialog-title {
  border-bottom: 1px solid #e2e8f0 !important;
  padding-bottom: 1rem !important;
}

.dashboard-appbar {
  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%) !important;
  backdrop-filter: blur(20px) !important;
}

.dashboard-appbar .MuiButton-root {
  color: white !important;
}

.dashboard-container {
  padding-top: 0 !important;
  min-height: calc(100vh - 64px);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Production/Production.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,gEAAgE;EAChE,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,2DAA2D;EAC3D,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,qDAAqD;EACrD,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,wEAAwE;EACxE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC","sourcesContent":[".dashboard-container {\n  min-height: 100vh;\n  padding: 2rem 0;\n}\n\n.dashboard-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  color: white;\n}\n\n.dashboard-title {\n  background: linear-gradient(135deg, #ffffff, #e2e8f0);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  /* margin-bottom: 0.5rem !important; */\n}\n\n.register-button {\n  background: linear-gradient(135deg, #ffffff, #f8fafc) !important;\n  color: #1e40af !important;\n  font-weight: 600 !important;\n  padding: 12px 32px !important;\n  border-radius: 12px !important;\n  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.2) !important;\n  text-transform: none !important;\n}\n\n.register-button:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 15px 40px rgba(255, 255, 255, 0.3) !important;\n}\n\n.registration-card {\n  height: 100%;\n  transition: all 0.3s ease !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  background: rgba(255, 255, 255, 0.95) !important;\n  backdrop-filter: blur(10px) !important;\n} \n\n.registration-card:hover {\n  transform: translateY(-8px) !important;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 1rem;\n}\n\n.status-chip {\n  font-size: 0.75rem !important;\n  height: 24px !important;\n}\n\n.card-details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.detail-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #64748b;\n}\n\n.dialog-title {\n  border-bottom: 1px solid #e2e8f0 !important;\n  padding-bottom: 1rem !important;\n}\n\n.dashboard-appbar {\n  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%) !important;\n  backdrop-filter: blur(20px) !important;\n}\n\n.dashboard-appbar .MuiButton-root {\n  color: white !important;\n}\n\n.dashboard-container {\n  padding-top: 0 !important;\n  min-height: calc(100vh - 64px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
